import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../common/html/button'
import { Element } from '../../../common/html/element'
import { Radio } from '../../../common/html/radio'
import classes from '../../index.module.scss'
import '../../lang/i18n'
import {
  ALL_FIELDS,
  ALL_REQUIRED_FIELDS,
  FORM_FIELDS,
  IS_VALID_FIELDS,
  KEYS_FIELD_LIST,
  LIST_RADIO_GENDER,
} from '../constants'
import {
  checkEmailValid,
  checkInvalidInputVal,
  checkPhoneValid,
} from '../helper'
import { PopupRequest } from '../popupRequest/PopupRequest'
import { selectJobTitlesList, selectUserProfile } from '../store/slice'
import { putUserProfile } from '../store/thunk'
import { LeftFields } from './LeftFields'
import { RightFields } from './RightFields'

export const FormEditProfile = () => {
  const dispatch = useDispatch()

  const userProfile = useSelector(selectUserProfile)
  const jobTitlesList = useSelector(selectJobTitlesList)

  const [isOpenPopupRequest, setIsOpenPopupRequest] = useState(false)
  const [form, setForm] = useState({})
  const [isValid, setIsValid] = useState(IS_VALID_FIELDS)
  const [gender, setGender] = useState(null)
  const [jobTitle, setJobTitle] = useState(null)

  const defaultJobTitle =
    jobTitlesList?.find((item) => item.id === userProfile?.jobTitleId) ||
    jobTitlesList[0]

  const onClosePopup = () => {
    setIsOpenPopupRequest(false)
    setIsValid(IS_VALID_FIELDS)
  }

  const createRequest = () => {
    setIsOpenPopupRequest(true)
  }

  const formFields = FORM_FIELDS.map((item) => ({ [item]: form[item] }))
  const newFormFieldsValue = {
    ...Object.assign({}, ...formFields),
    gender: gender,
    jobTitleId: jobTitle?.id || defaultJobTitle?.id,
  }

  const onSave = () => {
    const checkValidRequiredField = ALL_REQUIRED_FIELDS.map((item) => ({
      [item]: !checkInvalidInputVal(form[item]),
    }))
    const isValidAllField = {
      ...isValid,
      ...Object.assign({}, ...checkValidRequiredField),
    }

    setIsValid(isValidAllField)

    if (Object.values(isValidAllField).includes(false)) {
      return
    }

    dispatch(putUserProfile({ userProfile: newFormFieldsValue }))
  }

  const onChange = (key, event) => {
    const eventValue = event.target.value

    if (!!eventValue.trim()) {
      setIsValid({
        ...isValid,
        [key]: true,
      })
    }

    if (
      key === KEYS_FIELD_LIST.PHONE ||
      key === KEYS_FIELD_LIST.COMPANY_PHONE
    ) {
      if (!!eventValue.trim()) {
        if (!checkPhoneValid(eventValue.trim())) {
          return
        }
      }
    }

    if (key === KEYS_FIELD_LIST.CONTACT_EMAIL) {
      if (!!eventValue.trim()) {
        setIsValid({
          ...isValid,
          [key]: checkEmailValid(eventValue),
        })
      } else {
        setIsValid({
          ...isValid,
          [key]: true,
        })
      }
    }

    setForm({ ...form, [key]: eventValue })
  }

  useEffect(() => {
    let defaultForm = {}
    if (userProfile) {
      const allFieldFilled = ALL_FIELDS.map((item) => ({
        [item]: userProfile[item] || '',
      }))

      defaultForm = Object.assign({}, ...allFieldFilled)
      defaultForm.gender = userProfile?.gender || LIST_RADIO_GENDER[0].value
    }

    setGender(userProfile?.gender || LIST_RADIO_GENDER[0].value)
    setForm(defaultForm)
  }, [userProfile])

  return (
    <>
      <div className={classes.radioListContainer}>
        <Element className="fw600">
          <Translate value="userProfile.TITLE" />
        </Element>
        <div className={classes.radioList}>
          {LIST_RADIO_GENDER.map((item) => (
            <Radio
              key={item.title}
              title={item.title}
              isI18n
              value={item.value}
              appendStyle={{ marginRight: 40 }}
              activeValue={gender}
              isCheckOnClickText
              onChange={setGender}
            />
          ))}
        </div>
      </div>
      <div className={[classes.userProfileFormContainer, 'flex1'].join(' ')}>
        <LeftFields
          isValid={isValid}
          onChange={onChange}
          form={form}
          setJobTitle={setJobTitle}
          jobTitlesList={jobTitlesList}
          activeJobTitle={jobTitle || defaultJobTitle}
        />
        <div className={classes.formContent}>
          <RightFields form={form} isValid={isValid} onChange={onChange} />
        </div>
      </div>

      <div
        className={[
          'dFlex justifyContentBetween',
          classes.infoAndBtnContainer,
        ].join(' ')}
      >
        <Element className={classes.inforText}>
          <Translate value="userProfile.REQUEST_EDIT_INFO" />
          <span
            style={{ color: '#2C73E8', cursor: 'pointer' }}
            onClick={createRequest}
          >
            <Translate value="userProfile.REQUEST_EDIT" />
          </span>
        </Element>
        <div
          className={['dFlex justifyContentEnd gap1', classes.footer].join(' ')}
        >
          <Button
            label="userProfile.SAVE"
            style={{
              border: '1px solid #D5D5D5',
              backgroundColor: '#2c73e8',
              color: '#ffffff',
            }}
            action={onSave}
            isI18n
          />
        </div>
      </div>

      {isOpenPopupRequest && (
        <PopupRequest
          isOpen={isOpenPopupRequest}
          onClose={onClosePopup}
          userProfile={userProfile}
          setIsOpenPopupRequest={setIsOpenPopupRequest}
        />
      )}
    </>
  )
}
